<!-- email-modal.component.html -->
<div class="modal-fullscreen d-flex align-items-center justify-content-center"
     [ngClass]="darkMode ? 'bg-kia-dark-mode' : 'bg-kia-light-mode'"
     style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 1050;">
    <div class="modal-content border-0 shadow" style="max-width: 500px; width: 90%; max-height: 50vh;">
      <!-- Logo and welcome message -->
      <div class="text-center pt-4 pb-2">
        <img src="../../../../../assets/media/logos/new_kia_logo.png" alt="KIA Logo" class="img-fluid mb-3" style="width: 200px;">
        <h5 class="modal-title mb-3 pt-10">Welcome to KiaLearn Portal. Enter your email address to begin.</h5>
      </div>
      
      <!-- Email input area -->
      <div class="modal-body px-4 py-3">
        <form [formGroup]="emailForm">
          <div class="mb-4">
            <label for="emailInput" class="form-label">Email address</label>
            <input
              type="email"
              class="form-control"
              id="emailInput"
              formControlName="email"
              placeholder="Enter your email"
              [ngClass]="{'is-invalid': emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)}"
              [disabled]="isSubmitting"
            >
            <div class="text-danger small mt-1" *ngIf="emailForm.get('email')?.errors?.['required'] && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)">
              Email is required.
            </div>
            <div class="text-danger small mt-1" *ngIf="emailForm.get('email')?.errors?.email && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)">
              Please enter a valid email address.
            </div>
          </div>

          <!-- reCAPTCHA -->
          <div class="mb-4">
            <div class="d-flex justify-content-center align-items-center" style="min-height: 80px;">
              <re-captcha
                #recaptcha
                [siteKey]="recaptchaSiteKey"
                (resolved)="onRecaptchaResolved($event)"
                [ngClass]="{'is-invalid': emailForm.get('recaptcha')?.invalid && (emailForm.get('recaptcha')?.dirty || emailForm.get('recaptcha')?.touched)}"
              ></re-captcha>
            </div>
            <div class="text-danger small mt-1 text-center" *ngIf="emailForm.get('recaptcha')?.errors?.['required'] && (emailForm.get('recaptcha')?.dirty || emailForm.get('recaptcha')?.touched)">
              Please complete the security verification.
            </div>
            <div class="text-danger small mt-1 text-center" *ngIf="recaptchaError">
              {{ recaptchaError }}
            </div>
          </div>
        </form>
      </div>
      
      <!-- Button area -->
      <div class="modal-footer border-0 d-flex justify-content-center px-4 pb-4 pt-2">
        <button
          type="button"
          class="btn btn-primary px-4"
          style="background-color: #1EAAED; border: none;"
          [disabled]="emailForm.invalid || isSubmitting"
          (click)="submitEmail()">
          <span *ngIf="!isSubmitting">Next</span>
          <span *ngIf="isSubmitting">
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            Verifying...
          </span>
        </button>
      </div>
    </div>
  </div>